var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.order.delivery_tracking_link)?_c('a',{attrs:{"href":_vm.generateTrackingLink(_vm.order),"target":"_blank"}},[_vm._v(_vm._s(_vm.order.short_delivery_order_id || _vm.order.delivery_order_id))]):_c('span',[_vm._v(_vm._s(_vm.order.short_delivery_order_id || _vm.order.delivery_order_id))])])
}
var staticRenderFns = []

export { render, staticRenderFns }